query findEvent(
  $id: UUID!
) {
  event: eventByEventId(eventId: $id) {
    eventId
    eventName
    sportId
    startsAt
    isUsaView
    competitors
    matchState
    limbo
    eventReadiness: eventReadinessByEventId {
      isApproved
    }
    marketsOfferingStatus: operatorMarketTypeSuspensionForAllLinesByEventId {
      nodes {
        marketTypeWithoutLine
        operatorId
      }
    }
    competition {
      competitionId
      competitionName
      competitionFeedConfiguration: competitionFeedConfigurationsByCompetitionId {
        nodes {
          feed
          priority
        }
      }
    }
    sport {
      sportId
      sportName
      sportLabel
    }
    primaryFeedOverrides: eventPrimaryFeedOverridesByEventId {
      nodes {
        primaryFeeds
      }
    }
    bookedEvents: bookedEventsByEventId {
      nodes {
        isOfferedLive
        isOfferedPreMatch
      }
    }
    bookedPlayerProps: playerPropsBookedEventsByEventId {
      nodes {
        isOfferedLive
        isOfferedPreMatch
      }
    }
    bookedSameGameParlays: sgpBookedEventsByEventId {
      nodes {
        isOfferedLive
        isOfferedPreMatch
      }
    }
    bookedMicroMarkets: microBookedEventsByEventId {
      nodes {
        isOfferedLive
        isOfferedPreMatch
      }
    }
    soccerEventDetails: soccerAggregatesByEventId {
      nodes {
        actions
        attacksInMatch
        attacksPerPeriod
        available
        awayLineup
        awayScore
        awayScoreFirstLeg
        awayScorePenaltyShootout
        awayScoreRegularTime
        awayTeamId
        competitionType
        cornersInMatch
        cornersPerPeriod
        dangerousAttacksInMatch
        dangerousAttacksPerPeriod
        dangerousFreeKicksInMatch
        dangerousFreeKicksPerPeriod
        elapsedSecondInPeriod
        eventId
        eventInBreak
        eventPreMatch
        extraTimeHalfDuration
        firstYellowCardsInMatch
        firstYellowCardsPerPeriod
        foulsInMatch
        foulsPerPeriod
        freeKicksInMatch
        freeKicksPerPeriod
        goalKicksInMatch
        goalKicksPerPeriod
        halfDuration
        homeLineup
        homeScore
        homeScoreFirstLeg
        homeScorePenaltyShootout
        homeScoreRegularTime
        homeTeamId
        injuryTimeDuration
        injuryTimeDurationOfficial
        lastAction
        maxSubstitutions
        penaltiesInMatch
        penaltiesPerPeriod
        period
        redCardsInMatch
        redCardsPerPeriod
        riskFlags
        scorePerPeriod
        secondLeg
        shotsOffTargetInMatch
        shotsOffTargetPerPeriod
        shotsOnTargetInMatch
        shotsOnTargetPerPeriod
        source
        substitutionsInMatch
        substitutionsPerPeriod
        teamInPossession
        throwInsInMatch
        throwInsPerPeriod
        var
        varEnabled
        yellowCardsInMatch
        yellowCardsPerPeriod
        ownGoalsPerPeriod
        goalsFromPenaltyPerPeriod
        offsidesPerPeriod
        ownGoalsInMatch
        goalsFromPenaltyInMatch
        offsidesInMatch
        assistsInMatch
        accuratePassesInMatch
        totalPassesInMatch
        accurateCrossesInMatch
        totalCrossesInMatch
        tacklesInMatch
        interceptionsInMatch
        savesInMatch
      }
    }
    basketballEventDetails: basketballAggregatesByEventId {
      nodes {
        homeTeamId
        awayTeamId
        homeScore
        awayScore
        eventId
        ftsToCome
        nodeId
        otLengthInMinutes
        otPossible
        periodLengthInMinutes
        periods
        secondsLeftInPeriod
        teamInPossession
        lastTeamToScore
        competitionType
        period
        clockRunning
        source
        homeLineup
        awayLineup
        competitionType
        fieldGoalPerPeriod
        fieldGoalPercentagePerPeriod
        fieldGoalPercentageInMatch
        twoPointAttemptsPerPeriod
        threePointAttemptsPerPeriod
        reboundsPerPeriod
        assistsPerPeriod
        possessionsCountPerPeriod
        eventInBreak
        eventPreMatch
        actions
        stealsPerPeriod
        turnoversPerPeriod
        offensiveReboundsPerPeriod
        blocksPerPeriod
        available
      }
    }
    footballEventDetails: footballAggregatesByEventId {
      nodes {
        period
        gameTimeFromLastScoringEvent
        gameTimeElapsedInPeriod
        gameTimeRemainingInRegularGame
        inPossession
        downNumber
        yardsToWinDown
        lineOfScrimmageYard
        lineOfScrimmageTerritory
        yardsToEndZone
        isConversionEvent
        homeScore
        awayScore
        homeScoreFirstQuarter
        awayScoreFirstQuarter
        homeScoreSecondQuarter
        awayScoreSecondQuarter
        homeScoreThirdQuarter
        awayScoreThirdQuarter
        homeScoreFourthQuarter
        awayScoreFourthQuarter
        homeScoreOvertime
        awayScoreOvertime
        competitionName
        totalDownsNumber
        quarterDuration
        overtimeDuration
        overtimePossible
        homeTeamId
        awayTeamId
        source
        homeLineup
        awayLineup
        eventInBreak
        eventPreMatch
        available
      }
    }
    hockeyEventDetails: hockeyAggregatesByEventId {
      nodes {
        eventId
        lastTeamToScore
        period
        secondsLeftInPeriod
        scorePerPeriod
        foulsPerPeriod: penaltiesPerPeriod
        periods
        periodLengthInMinutes
        competitionType
        otPossible
        otLengthInMinutes
        homeTeamId
        awayTeamId
        homeScore
        awayScore
        clockRunning
        timeOfLastClockStart
        lastUpdated
        source
        available
        teamInPossession
        eventInBreak
        eventPreMatch
        homeLineup
        awayLineup
        powerPlayAdvantage
      }
    }
    baseballEventDetails: baseballAggregatesByEventId {
      nodes {
        eventId
        source
        lastUpdated
        matchRuns
        pitchCount
        loadedBases
        matchHits
        inningDetails
        currentTeamAPitcherProviderId
        currentTeamABatterProviderId
        currentTeamBPitcherProviderId
        currentTeamBBatterProviderId
        teamABatterIds
        teamBBatterIds
        teamAPitcherIds
        teamBPitcherIds
        matchHomeRuns
        raceToMap
        available
        extraInningsSecondBaseRule
        regularInningsToBePlayed
        mercyRulePossible
        mercyRuleInningThreshold
        mercyRuleRunsAheadThreshold
        tiePossible
        tiePossibleInningThreshold
        homeTeamId
        awayTeamId
        eventInBreak
        eventPreMatch
        homeLineup
        awayLineup
      }
    }
    tennisEventDetails: tennisAggregatesByEventId {
      nodes {
        source
        lastUpdated
        homeTeamId
        awayTeamId
        available
        period
        matchTime
        setDurations
        currentServingTeam
        currentGameNumber
        currentGameScore
        pointsWonPerGame
        gamesWonInMatch
        gamesWonPerSet
        setsWon
        isPointInProgress
        secondServe
        eventPrematch
        eventPostmatch
        eventInBreak
        setsToPlay
        isDoubles
        isMen
        noAdvantage
        lastSetSuperTiebreak
        lastScoreUpdate
        lastSetSuperTiebreakPoints
        acesInMatch
        acesPerSet
        doubleFaultsInMatch
        doubleFaultsPerSet
        breakPointsPlayedInMatch
        breakPointsWonInMatch
        breakPointsPlayedPerSet
        breakPointsWonPerSet
        breakPointsWonPercentageInMatch
        breakServePointsWonPercentagePerSet
        firstServePercentageInMatch
        firstServePercentagePerSet
        firstServePointsPlayedInMatch
        firstServePointsPlayedPerSet
        firstServePointsWonInMatch
        firstServePointsWonPerSet
        firstServePointsWonPercentageInMatch
        firstServePointsWonPercentagePerSet
        secondServePercentageInMatch
        secondServePercentagePerSet
        secondServePointsPlayedInMatch
        secondServePointsPlayedPerSet
        secondServePointsWonInMatch
        secondServePointsWonPerSet
        secondServePointsWonPercentageInMatch
        secondServePointsWonPercentagePerSet
      }
    }
    operatorEventSuspensionsByEventId {
      nodes {
        operatorId
      }
    }
    pricingProbabilitiesByEventId {
      nodes {
        probabilities
      }
    }
    defaultBookieWeightsAreUsedForEventsByEventId {
      edges {
        node {
          isDefaultConfigurationGame
          isDefaultConfigurationPlayerProps
        }
      }
    }
    competitionForEventIsMappedsByEventId {
      edges {
        node {
          isMapped
        }
      }
    }
    mappings: eventMappingsByIntId {
      nodes {
        feed
        mappingType
        competitionMapping {
          mappingType
        }
      }
    }
  }
}
